// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f92cf98f105c5b2ef0f2","682":"4394917376757677cd0a","883":"71c1fe2205808b9ad0e3"}[chunkId] + ".js";
};